module.exports = __webpack_public_path__ + "static/img/8.9fdbdf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/8.png
// module id = LnMo
// module chunks = 1